import styled from 'styled-components';

export const EmbedWrapper = styled.div.withConfig({
    displayName: 'EmbedWrapper',
    componentId: 'embed-wrapper',
})([
    `
    margin-bottom: 32px;

    > iframe {
        width: 100% !important;
    }

    > iframe {
        height: calc((100vw - 57px) * 9 / 16) !important;
    }

    @media screen and (min-width: 961px) {
      > iframe {
        height: calc((100vw - 65px) * 9 / 16) !important;
      }
    }

    @media screen and (min-width: 1185px) {
      > iframe {
        height: calc(1120px * 9 / 16) !important;
      }
    }

    @media screen and (min-width: 1281px) {
      > iframe {
        height: calc((836px * 9) / 16) !important;
      }
    }
`]);

export const ParagraphWrapper = styled.div.withConfig({
    displayName: 'ParagraphWrapper',
    componentId: 'paragraph-wrapper',
})([
    `
    margin-bottom: 32px;

    > *, > p {
        font-size: inherit;
        > a {
            color: #2D91FF;
        }
    }

    > div > h1, h2, h3, h4, h5, h6 {
        margin-top: 32px;
        margin-bottom: 16px;
    }

    > div {
        h2, h3 {
            font-weight: 530;
            line-height: 24px;
            word-wrap: break-word
        }

        h2 {
            font-size: 24px;
        }

        h3 {
            font-size: 20px;
        }

        img {
            max-width: 100%;
        }

        figure {
            margin: 0;
            &.image.image-style-side {
                float: right;
                max-width: 50%;
                margin-top: 5px;
                margin-left: 10px;
            }
        }
    }

    &.paragraph-with-image {
        .paragraph-content-wrapper {
            display: flex;
            align-items: flex-start;
            gap: 32px;
            flex-direction: row;

            @media screen and (max-width: 767px) {
                flex-direction: column;
                gap: 16px;
            }
        }

        .paragraph-text {
            flex: 1;
            min-width: 0;
        }

        &.paragraph-image-links {
            .paragraph-content-wrapper {
                flex-direction: row;

                @media screen and (max-width: 767px) {
                    flex-direction: column;
                }
            }
        }

        &.paragraph-image-rechts {
            .paragraph-content-wrapper {
                flex-direction: row-reverse !important;

                @media screen and (max-width: 767px) {
                    flex-direction: column;
                }
            }
        }
    }

    &.paragraph-with-video {
        .paragraph-content-wrapper {
            display: flex;
            align-items: flex-start;
            gap: 32px;
            flex-direction: row;

            @media screen and (max-width: 767px) {
                flex-direction: column;
                gap: 16px;
            }
        }

        .paragraph-text {
            flex: 1;
            min-width: 0;
        }

        &.paragraph-video-links {
            .paragraph-content-wrapper {
                flex-direction: row;

                @media screen and (max-width: 767px) {
                    flex-direction: column;
                }
            }
        }

        &.paragraph-video-rechts {
            .paragraph-content-wrapper {
                flex-direction: row-reverse !important;

                @media screen and (max-width: 767px) {
                    flex-direction: column;
                }
            }
        }
    }

    h2, h3, h4, h5 {
        scroll-margin-top: 96px;
    }

    .copy-id-h-tag {
        h2, h3, h4, h5 {
            a svg {
                position: absolute;
                display: inline-block;
                width: 24px;
                height: 24px;
                margin-left: 12px;
                fill: #FFF;
                path {
                    color: #FFF;
                    fill: #FFF;
                }
            }
        }

        &:hover {
            h2, h3, h4, h5 {
                cursor: pointer;
            }

            a svg {
                fill: #2D91FF;
                path {
                    color: #2D91FF;
                    fill: #2D91FF;
                }
            }
        }

        .ard-tooltip {
            z-index: 1001;
            font-family: "The Sans", "TheSans C5", "sans-serif";
            font-weight: 400;
            font-size: 14px;
            background-color: #EEF0F1;
            opacity: unset;
            margin-top: 8px;
            margin-left: -16px;
            padding: 4px 12px;
            border-radius: 2px;

            .react-tooltip-arrow {
                display: none;
            }
        }
    }
`,
]);
